export default function numberWithCommas(x) {
  // return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")

  return typeof x === "string" || typeof x === "number"
    ? typeof x === "string"
      ? parseFloat(x).toLocaleString("en-US")
      : x.toLocaleString("en-US")
    : x;
}
